import { IsNotEmpty, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class DocumentTemplateBrandDataService extends DataService<typeof Model.General.Logic.ViewModels.DocumentTemplateBrandItem, Model.General.Logic.ViewModels.DocumentTemplateBrandItem, DocumentTemplateBrandItem> {
	protected map(entity: Model.General.Logic.ViewModels.DocumentTemplateBrandItem): DocumentTemplateBrandItem {
		return new DocumentTemplateBrandItemModel(entity);
	}

	private id = -1;
	static make(ctx?: any): DocumentTemplateBrandDataService {
		return new DocumentTemplateBrandDataService(ctx, ctx => ctx.DocumentTemplateBrands, false);
	}

	add(template: IDocumentTemplateItem): Promise<DocumentTemplateBrandItem> {
		const entity = new Model.General.Logic.ViewModels.DocumentTemplateBrandItem();
		if (template.id > 0) {
			entity.documentTemplateId = template.id;
		} else {
			entity.documentTemplate = template.entity;
		}
		entity.id = this.id--;

		return this.create(() => entity);
	}
}

export class DocumentTemplateBrandItemModel extends EntityModel<Model.General.Logic.ViewModels.DocumentTemplateBrandItem, DocumentTemplateBrandItem> implements DocumentTemplateBrandItem {
	@property<DocumentTemplateBrandItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<DocumentTemplateBrandItemModel>(o => o.entity.documentTemplateId, (o, value) => o.entity.documentTemplateId = value)
	//@IsDefined({ message: "agent is required" })
	public documentTemplateId: number;

	@property<DocumentTemplateBrandItemModel>(o => o.entity.brandId, (o, value) => o.entity.brandId = value)
	@IsDefined({ message: 'Brand is required' })
	public brandId: number;

	@property<DocumentTemplateBrandItemModel>(o => o.entity.brandName, (o, value) => o.entity.brandName = value)
	@IsDefined({ message: 'BrandName is required' })
	public brandName: string;
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/brands/brand-form.data.ts